import { useQuery } from "@apollo/client/react";
import { GET_USER_ORGANIZATIONS } from "@/graphql/queries";
import { useCurrentOrganization } from "@/hooks/useCurrentOrganization";

export type UserRole = "admin" | "member" | "owner";

export function useUserRole() {
  const { data, loading } = useQuery<{ me?: { organizations?: { id: string; name: string; role: string; isPersonal?: boolean }[] } | null }>(GET_USER_ORGANIZATIONS, {
    errorPolicy: 'all',
  });

  const organizations = data?.me?.organizations || [];
  // Use the shared hook to get the current organization consistently
  const { currentOrg } = useCurrentOrganization(organizations);
  
  // Backend returns uppercase roles: OWNER, ADMIN, MEMBER
  const roleString = currentOrg?.role?.toUpperCase() || "";
  const role: UserRole = roleString === "OWNER" ? "owner" : roleString === "ADMIN" ? "admin" : "member";
  const isOwner = roleString === "OWNER";
  const isAdmin = roleString === "OWNER" || roleString === "ADMIN";

  return { role, isOwner, isAdmin, loading };
}
